import BenchlingConfig from 'BenchlingConfig';

/**
 * Typesafe convenience utility for getting the value of a config flag.
 *
 * Usage: getConfig('ENABLE_REGISTRY') => true;
 */
export default function getConfig<K extends keyof typeof BenchlingConfig>(
  config: K
): (typeof BenchlingConfig)[K] {
  return BenchlingConfig[config];
}
